// analytics/TrackingLayout.tsx
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { isTrackingEnabled } from "./events";

export const TrackingLayout = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isTrackingEnabled()) {
      return;
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "spa_route_change",
      page_path: location.pathname,
      page_location: window.location.href,
    });
  }, [location.pathname]);

  return <Outlet />;
};